import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DataTest } from './data-test';

export interface LeerProductoContenedorEmpaquetadoRequest {
    iId: number
    cContenedor: string
    cDocumento: string
    cPedido: string
    cUbicacion: string
    cProducto: string
    dCantidad: number
    cUsuarioPDA: string
}

export interface ObtenerContenedorEmpaquetadoRequest {
    iId:         number;
    cContenedor: string;
    cUsuarioPDA: string;
    cPuesto: string;
}


@Injectable()
export class TestServerInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let result: Observable<HttpEvent<unknown>> | undefined;
    if (request.method === 'POST') {
      console.log(`Request intercepted ${request.url}`, request.body);
      result = this.postRequest(request, next);
    }
    if (result !== undefined) {
      return result;
    } else {
      console.log(`Request not intercepted ${request.url}`);
      return next.handle(request);
    }
  }

  private responseWithData(data: unknown): Observable<HttpEvent<unknown>> {
    return of(new HttpResponse({
      body: {
        "@odata.context": "https://api.businesscentral.dynamics.com/v2.0/ef42d319-47c9-4f6b-b37f-e795d2bd1c5e/SBCosmos/ODataV4/$metadata#Edm.String",
        "value": JSON.stringify(data)
      },
      status: 200
    }))

  }
  private postRequest(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> | undefined {
    let result: Observable<HttpEvent<unknown>> | undefined;
    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_ObtenerContenedorEmpaquetado?Company=\'ORBIT\'')) {
      const id = (request.body as ObtenerContenedorEmpaquetadoRequest).cContenedor;
      if (id !== undefined) {
        switch (id.toUpperCase()) {
          case 'TROL0009':
            result = this.responseWithData(DataTest.container.trol0009);
            break;
          case 'TROL0010':
            result = this.responseWithData(DataTest.container.trol0010);
            break;
          case 'TROL0013':
            result = this.responseWithData(DataTest.container.trol0013);
            break;
          case 'KART0001':
            result = this.responseWithData(DataTest.container.kart0001);
            break;
          case '101256':
            result = this.responseWithData(DataTest.container.pedido101256);
            break;
          case '101000':
            result = this.responseWithData(DataTest.container.pedido101000);
            break;
          case '101466':
            result = this.responseWithData(DataTest.container.pedido101466);
            break;
          case '101431':
            result = this.responseWithData(DataTest.container.pedido101431);
            break;
          case '101441':
            result = this.responseWithData(DataTest.container.pedido101441);
            break;
          default:
            break;
        }
      }
    }
    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_ObtenerListaCajasEmpaquetado?Company=\'ORBIT\'')) {
      result = this.responseWithData(DataTest.obtenerContenedorEmpaquetadoResponse);
    }

    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_LeerProductoContenedorEmpaquetado?Company=\'ORBIT\'')) {
      const sku = (request.body as LeerProductoContenedorEmpaquetadoRequest).cProducto;
      if (sku !== undefined) {
        switch (sku.toUpperCase()) {
          case 'SKU1008':
            result = this.responseWithData(DataTest.leerProductoSKU1018);
            break;
            case 'SKU2000':
              result = this.responseWithData(DataTest.leerProductoSKU2000);
              break;
        }
      }
    }

    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_CrearCajaEmpaquetado?Company=\'ORBIT\'')) {
      result = this.responseWithData(DataTest.crearCaja);
    }

    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_CambiarTipoCajaEmpaquetado?Company=\'ORBIT\'')) {
      result = this.responseWithData(DataTest.cambiarCaja);
    }

    if (request.url.includes('/SBCosmos/ODataV4/CosmosApi_CerrarContenedorEmpaquetado?Company=\'ORBIT\'')) {
      result = this.responseWithData(DataTest.cerrarCaja);
    }

    return result;
  }

}
